// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test'
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeAutoCompleteResizeMenu = function() {};
})();
	